import { CognitoUser } from "amazon-cognito-identity-js";
import { MobXProviderContext } from "mobx-react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useContext, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { RouterAddress } from "../../../constants/RouterAddress";
import AuthLayout from "../components/AuthLayout";
import { appFormSectionStyle, appMutedTextStyle } from "../../../components/general/uiSurfaceStyles";
import { useAuthExperience } from "../hooks/useAuthExperience";
import { getCognitoBrandClientMetadata } from "../config/brandOverride";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { authStore } = useContext(MobXProviderContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const authExperience = useAuthExperience();

  const defaultValues = {
    email: '',
  }
  const { control, formState: { errors }, handleSubmit, reset } = useForm({ defaultValues });

  const getFormErrorMessage = (name) => {
    return errors[name] && <small className="p-error">{errors[name].message}</small>
  };


  const onSubmit = async (data: any) => {
    setLoading(true);
    setErrorMessage("");
    const email = data.email.toLowerCase();
    const cognitoUser = new CognitoUser({
      Username: email,
      Pool: authStore.userPoolProps,
    });

    cognitoUser.forgotPassword({
      onSuccess: () => {
        setLoading(false);
        reset();
        navigate(RouterAddress.RESET_PASSWORD, { state: { email } });
      },
      onFailure: (error) => {
        console.error(error);
        setErrorMessage(error.message);
        setLoading(false);
      },
    }, getCognitoBrandClientMetadata());
  };
  return (
    <AuthLayout title="Forgot Password" subtitle={authExperience.auth.forgotPasswordSubtitle}>
      <form onSubmit={handleSubmit(onSubmit)} className="justify-content-center align-items-center flex-column flex" style={appFormSectionStyle}>
        <div className="field">
          <span className="p-float-label">
            <Controller name="email" control={control} rules={{
              required: 'Email is required.',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: 'Invalid email address. E.g. example@email.com'
              }
            }} render={({ field, fieldState }) => (
              <InputText id={field.name} {...field} className={classNames({ 'p-invalid': fieldState.invalid })} />
            )} />
            <label htmlFor="email" className={classNames({ 'p-error': errors.email })}>Email</label>
          </span>
          {getFormErrorMessage('email')}
        </div>

        <small className="text-600 mb-3 block" style={appMutedTextStyle}>
          When you reset your password, use 12 or more characters with at least one uppercase letter, one lowercase letter, and one number.
        </small>

        <div className="p-error">{errorMessage}</div>

        <Button type="submit" label="Submit" severity="warning" rounded className="mt-2 p-button-outlined" loading={loading} />

        <div className="grid" style={{ minWidth: "70%", alignItems: "center", textAlign: "center", marginTop: "1em" }}>
          <p className="col">
            Back to - &nbsp;
            <a onClick={() => navigate(RouterAddress.LOGIN_PAGE)}>
              Login
            </a>
          </p>
        </div>
      </form>
    </AuthLayout>
  );
};

export default ForgotPassword;
